import React, { useEffect, useState } from 'react';
import { trackFb } from '../utils/fbPixel';
const trackFbEvent = (event: string, data?: Record<string, any>) => {
  trackFb(event, data);
};
type Plan = 'megapack' | 'megapack-pro';
export function Pricing() {
  useEffect(() => {
    const section = document.getElementById('pricing');
    if (!section) return;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        trackFbEvent('ViewContent', {
          content_name: 'Pricing Section',
          content_category: 'Kinesiología Resuelta'
        });
        observer.disconnect();
      }
    }, {
      threshold: 0.3
    });
    observer.observe(section);
    return () => observer.disconnect();
  }, []);
  const [selected, setSelected] = useState<Plan>('megapack-pro');
  const cartUrls: Record<Plan, string> = {
    megapack: 'https://checkout.construyeprogreso.com/cart/48271060336810:1',
    'megapack-pro': 'https://checkout.construyeprogreso.com/cart/48271060730026:1'
  };
  const plans = {
    megapack: {
      emoji: '🦴',
      name: 'MEGAPACK KINESIOLOGÍA RESUELTA',
      desc: '6 tomos + 6 bonos · Sistema clínico completo',
      priceOld: '$58.990',
      priceNew: '$19.990',
      cta: '→ SÍ, QUIERO EL MEGAPACK',
      sub: '6 tomos · 6 bonos · Acceso inmediato'
    },
    'megapack-pro': {
      emoji: '🏆',
      name: 'MEGAPACK + MÉTODO KINE-PRO',
      desc: 'Todo el Megapack + razonamiento clínico avanzado, gestión operativa y alta rentabilidad.',
      priceOld: '$102.990',
      priceNew: '$27.990',
      cta: '→ SÍ, QUIERO EL MEGAPACK + MÉTODO KINE-PRO',
      sub: '6 tomos · 6 bonos · Método KINE-PRO™ · Acceso inmediato'
    }
  };
  const active = plans[selected];
  return <section id="pricing" className="w-full px-4 sm:px-6 lg:px-8 py-12 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,249,255) 0%, rgb(224,247,255) 15%, rgb(224,247,255) 85%, rgb(235,248,255) 100%)',
    fontFamily: 'var(--font-system)'
  }} data-id="element-189">
      <div className="mx-auto max-w-3xl" data-id="element-190">
        {/* Heading */}
        <div className="text-center mb-8" data-id="element-191">
          <div className="inline-flex items-center gap-2 text-[11px] font-bold tracking-wide rounded-full px-4 py-1.5 mb-4" style={{
          color: '#0077B6',
          border: '1px solid rgba(0,119,182,0.40)',
          backgroundColor: 'rgba(0,119,182,0.05)'
        }} data-id="element-192">
            🔥 Precio de lanzamiento — Sube sin previo aviso
          </div>
          <h2 className="text-2xl sm:text-3xl font-black text-gray-900 m-0 mb-2" data-id="element-193">
            Elegí tu{' '}
            <span style={{
            color: '#0077B6'
          }} data-id="element-194">
              Megapack:
            </span>
          </h2>
          <p className="text-xs text-gray-500 m-0" data-id="element-195">
            Las dos opciones incluyen los 6 bonos estratégicos completos
          </p>
        </div>

        {/* Plan Selector */}
        <div className="flex flex-col gap-3 mb-6" data-id="element-196">
          {(Object.keys(plans) as Plan[]).map(plan => {
          const p = plans[plan];
          const isSelected = selected === plan;
          return <button key={plan} onClick={() => setSelected(plan)} className="w-full text-left rounded-xl p-4 transition-all cursor-pointer" style={{
            border: isSelected ? '2px solid #0077B6' : '1px solid #e5e7eb',
            backgroundColor: isSelected ? 'rgba(0,119,182,0.05)' : 'rgb(255,255,255)',
            boxShadow: isSelected ? '0px 0px 30px 0px rgba(0,119,182,0.15)' : undefined
          }} data-id="element-197">
                <div className="flex items-center gap-3" data-id="element-198">
                  {/* Radio */}
                  <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2" style={{
                borderColor: isSelected ? '#0077B6' : '#d1d5db'
              }} data-id="element-199">
                    {isSelected && <div className="h-2.5 w-2.5 rounded-full" style={{
                  backgroundColor: '#0077B6'
                }} data-id="element-200" />}
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0" data-id="element-201">
                    <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-202">
                      <span data-id="element-203">{p.emoji}</span>
                      <span className="text-sm font-black text-gray-900" data-id="element-204">
                        {p.name}
                      </span>
                      {plan === 'megapack-pro' && <span className="text-[10px] font-black text-white rounded-full px-2 py-0.5" style={{
                    backgroundColor: '#0077B6'
                  }} data-id="element-205">
                          ⭐ MÁS ELEGIDO
                        </span>}
                    </div>
                    <p className="text-xs text-gray-500 m-0" data-id="element-206">{p.desc}</p>
                  </div>

                  {/* Price */}
                  <div className="shrink-0 text-right" data-id="element-207">
                    <div className="text-xs text-gray-400 line-through" data-id="element-208">
                      {p.priceOld}
                    </div>
                    <div className="text-2xl font-black" style={{
                  color: isSelected ? '#0077B6' : '#111827'
                }} data-id="element-209">
                      {p.priceNew}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* CTA Block */}
        <div className="rounded-2xl p-5 shadow-lg" style={{
        background: 'linear-gradient(135deg, rgb(0,96,145), rgb(0,119,182))'
      }} data-id="element-210">
          {/* What you get summary */}
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 mb-4" data-id="element-211">
            {active.sub.split(' · ').map(item => <span key={item} className="text-[11px] font-bold text-white/90 flex items-center gap-1" data-id="element-212">
                <span className="text-white/60" data-id="element-213">✓</span> {item}
              </span>)}
          </div>

          {/* Main CTA */}
          <a href={cartUrls[selected]} onClick={() => trackFbEvent('InitiateCheckout', {
          content_name: selected === 'megapack-pro' ? 'Megapack + Método KINE-PRO' : 'Megapack Kinesiología Resuelta',
          content_category: 'Kinesiología Resuelta',
          value: selected === 'megapack-pro' ? 27990 : 19990,
          currency: 'ARS'
        })} className="block w-full text-center text-sm sm:text-base font-black rounded-xl py-4 no-underline transition-all hover:scale-[1.02] active:scale-[0.98]" style={{
          backgroundColor: 'white',
          color: '#0077B6',
          border: '3px solid rgba(0,119,182,0.40)',
          boxShadow: '0 4px 15px rgba(0,0,0,0.20), 0 0 0 1px rgba(255,255,255,0.15) inset'
        }} data-id="element-214">
            {active.cta}
          </a>

          {/* Subline */}
          <p className="text-center text-[11px] text-white/70 mt-3 mb-0" data-id="element-215">
            Más de 400 kinesiólogos ya trabajan con protocolo y cobran lo que
            merecen
          </p>
        </div>

        {/* Trust Badges */}
        <div className="mt-4 flex flex-wrap items-center justify-center gap-3 text-xs text-gray-500 bg-white rounded-xl px-4 py-3 shadow-sm border border-gray-100" data-id="element-216">
          <span data-id="element-217">🔒 Pago seguro</span>
          <span data-id="element-218">⚡ Acceso en 5 min</span>
          <span data-id="element-219">🛡️ Garantía 7 días</span>
          <span data-id="element-220">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}